<template>
    <v-row align="center">
        <v-col>
            <v-row align="center" class="row--small">
                <v-col> <v-currency-field v-model="form.age.value__min" :label="`최소연령`" outlined prefix="만" suffix="세" class="text-right" @input="emit" /> </v-col>
                <v-col cols="auto"> ~ </v-col>
                <v-col> <v-currency-field v-model="form.age.value__max" :label="`최대연령`" outlined prefix="만" suffix="세" class="text-right" @input="emit" /> </v-col>
            </v-row>
        </v-col>
        <v-col cols="auto">
            <v-switch v-model="form.age.isIrrelevant" label="연령무관" dense inset hide-details @input="emit" />
        </v-col>
        <v-col cols="12" class="mt-lg-n14">
            <discrimination-dialog-age>
                <template #activator="{ attrs, on }">
                    <v-btn small text color="primary" v-bind="attrs" v-on="on" class="mx-n12"> ※ 연령차별금지 / 고용상 연령차별 금지에 관한 법률 </v-btn>
                </template>
            </discrimination-dialog-age>
        </v-col>
    </v-row>
</template>

<script>
import { initRecruitmentField__qualification } from "@/assets/variables";

import DiscriminationDialogAge from "./discrimination-dialog-age.vue";

export default {
    components: {
        DiscriminationDialogAge,
    },
    props: {
        value: { type: Object, default: initRecruitmentField__qualification },
    },
    data: () => ({
        form: initRecruitmentField__qualification(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitmentField__qualification(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
.row--small{
    margin: -5px -2px;
    >[class*=col]{
        padding: 5px 2px;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .row--small{
        margin: -5px;
        >[class*=col]{
            padding: 5px;
        }
    }
}
@media (min-width:1200px){
}

</style>